<p-toast key="resetPassword" position="top-right"></p-toast>

<div class="resert-pass-container">
    <ng-container *ngIf="!validationDataSuccess; else successMessage">

        <ng-container *ngIf="dataUser; else formDataResponse">
            <form [formGroup]="formDataUser" novalidate>
                <a id="close-dialog-alta" class="close-dialog" (click)="closeModal()">
                    <img src="assets/images/icons/close_dialog_icon.svg" alt="close">
                </a>
                <div class="title">
                    <label for="user">¿{{ 'Olvidaste tu contrasena' | translate }}?</label>
                </div>
                <div class="message mt-1">
                    <label for="user">{{ 'Ingresa la informacion requerida para ayudarte a restablecer tu contrasena' | translate }}
                        .</label>
                </div>
                <div class="message mt-1">
                    <label for="user" class="error-message">*{{ 'Campos obligatorios' | translate }}</label>
                </div>
                <div class="message mt-2">
                    <label for="user">*{{ 'Razon Social o Titular' | translate }}</label>
                    <input formControlName="titularName" type="text" class="form-control rstpass"
                           placeholder="{{'Ingresa los datos como aparece en tu contrato'|translate}}">
                </div>
                <div *ngIf="showtipsToken" class="message mt-2"
                     style="font-family: Roboto, sans-serif; background-color: rgb(64, 63, 63); border-radius: 4px;">
                    <div style="font-family: Roboto, sans-serif; color: white; font-size: 10px; margin-left: 10px;">{{ 'Token fisico'|translate }}
                        , {{ 'el numero se encuentra en la parte trasera de tu dispositivo' | translate }}.
                    </div>
                    <div style="font-family: Roboto, sans-serif; color: white; font-size: 10px; margin-left: 10px;">{{ 'Token digital' |translate }}
                        , {{ 'ingresa a la app y selecciona Llave Digital para obtener mas informacion' | translate }}.
                    </div>
                </div>
                <div class="message mt-2 d-flex">
                    <div style="width: 47%;">
                        <label for="user"
                               style="font-family: Roboto, sans-serif; font-weight: 400;">*{{ 'No. de Contrato' | translate }}</label>
                        <input formControlName="noContrato" type="number" class="form-control rstpass"
                               placeholder="{{'Ingresa los 7 digitos'|translate}}">
                    </div>
                </div>
                <div class="message mt-2">
                    <label for="user"
                           style="font-family: Roboto, sans-serif; font-weight: 400;">*{{ 'Correo electronico' | translate }}</label>
                    <input formControlName="correoElectronico" type="email" class="form-control rstpass"
                           placeholder="{{'Ingresa el correo autorizado en tu contrato'|translate}}">
                </div>
                <div class="message mt-2" style="font-family: Roboto, sans-serif;">
                    <label for="user"
                           style="font-family: Roboto, sans-serif; font-weight: 400;">*{{ 'Nombre de usuario' | translate }}</label>
                    <input formControlName="nomUsuario" type="text" class="form-control rstpass"
                           placeholder="{{'Ingresa el usuario de la Banca digital'|translate}}">
                </div>
                <div class="btns-container mt-4">
                    <button class="btn-primary btn" [disabled]="formDataUser.invalid" (click)="validateDataForm()">
                        <ng-container *ngIf="validating; else continue">
                            <div style="font-size: 1rem;">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                {{ 'Validando'|translate }}...
                            </div>
                        </ng-container>
                        <ng-template #continue>
                            <span style="font-size: 1rem;">{{ 'Enviar' | translate }}</span>
                        </ng-template>
                    </button>
                </div>
            </form>
        </ng-container>
        <ng-template #formDataResponse>
            <a class="close-dialog" (click)="closeModal()">
                <img src="assets/images/icons/close_dialog_icon.svg" alt="close">
            </a>
            <ng-container *ngIf="formDataUserValid; else formDataUserInvalid">
                <div class="reset-password-code mt-3 p-3">
                    <div class="warning-icon text-center w-100">
                        <img src="assets/icons/warning.png" alt="Monex">
                    </div>
                    <div class="text-container-title mt-3">
                        {{ "resetPassword.label" | translate }}
                    </div>
                    <div class="text-container-body mt-3">
                        {{ "resetPassword.bodyModal.label1" | translate }}
                        <strong> {{ "resetPassword.bodyModal.label2" | translate }}</strong> {{ "resetPassword.bodyModal.label3" | translate }}
                    </div>
                    <div class="container-code">
                        <code-input [isCodeHidden]="false"
                                    [codeLength]="6"
                                    (codeChanged)="onCodeChanged($event)"
                                    (codeCompleted)="onCodeCompleted($event)">
                        </code-input>
                    </div>

                    <div class="btn-actions-container mt-4">
                        <button class="btn btn-secondary" (click)="resendToken()">
                            <div style="font-size: 1rem;" *ngIf="resendingToken">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                {{ 'Reenviando '|translate }}...
                            </div>
                            <div *ngIf="!resendingToken">
                                {{ "resetPassword.resendCodeLabel" | translate }}
                            </div>
                        </button>
                        <button class="btn btn-primary" [disabled]="!validCode || validatingCode"
                                (click)="validateOtpResetPassword()">
                            <div style="font-size: 1rem;" *ngIf="validatingCode">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                {{ 'Validando'|translate }}...
                            </div>
                            <div *ngIf="!validatingCode">
                                {{ "commons.continue" | translate }}
                            </div>
                        </button>
                    </div>
                </div>
            </ng-container>
            <ng-template #formDataUserInvalid>
                <div class="modal-title" style="text-align: center;">
                    <div class="mt-4">
                        <img class="icon" src="assets/images/icons/error-process.png">
                    </div>
                </div>
                <div class="alert-message">
                    {{ titleError | translate }}
                </div>
                <div class="modal-body">
                    <p>{{ errorMessage | translate }}.</p>
                </div>
                <div style="text-align: center;">
                    <button class="btn-primary btn" (click)="showFormDataUser()">
                        <span style="font-size: 1rem;">{{ 'Intentar de nuevo' | translate }}</span>
                    </button>
                </div>

            </ng-template>

        </ng-template>
    </ng-container>

    <ng-template #successMessage>
        <div class="success-message-container text-center">
            <a class="close-dialog" (click)="closeModal()">
                <img src="assets/images/icons/close_dialog_icon.svg" alt="close">
            </a>
            <div class="icon-container mt-4">
                <img src="assets/images/icons/checkmark_success.svg" alt="Success">
            </div>
            <div class="text-container-title mt-4">
                {{ 'Información recibida' | translate }}
            </div>
            <div class="text-container-body mt-3">
                {{ 'Te enviamos un correo electronico con indicaciones para restablecer tu contrasena' | translate }}
            </div>
        </div>
    </ng-template>
</div>
